import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import RestaurantDetailClient from '../../startup/RestaurantDetailClient.client.tsx';

ReactOnRails.register({RestaurantDetailClient});